import React from 'react';
import { Icon } from '@beisen/chaos-ui';

require('./DataBlock.css');

class DataBlockItem extends React.Component {
	constructor(props) {
		super(props);
		this.touchTapHandler = this.touchTapHandler.bind(this);

		this.state = {
			isActive: props.isActive
		};
	}

	componentWillReceiveProps(nextProps) {
		if(this.state.isActive != nextProps.isActive) {
			this.setState({ isActive: nextProps.isActive });
		}
	}
    // shouldComponentUpdate(nextProps, nextState) {
    // 	return !this.props.isMultiple || nextProps.selectKey == this.props.item.value;
    // }
    touchTapHandler(e) {
    	e.preventDefault();
    	this.setState({ isActive: !this.state.isActive }, () => {
    		this.props.handleToggleItem();
    	});
    }

    render() {
        return (
            <div className={'dataBlockItem '  + this.props.classLen + ' ' + (this.state.isActive ? 'active' : '')}
				 onTouchTap={this.touchTapHandler}
			>
			 	{this.props.item.text}
				<Icon icon='m-sys-guanbisanjiao' className='blockClose' />
			</div>
        );
    }
}

export default DataBlockItem;



// WEBPACK FOOTER //
// ./src/components/Field_Components/DataBlock/DataBlockItem.js